<template>
  <transition appear name="slide-fade">
    <div class="administracion-prospectos">
      <div class="container">
        <div class="instrucciones" v-if="tipoUsuario == 1">
          <h4 class="instrucciones--titulo">¡Bienvenido embajador!</h4>
          <p class="instrucciones--texto">
            Realiza el alta de tus nuevos prospectos y dale seguimiento. Una vez
            creados podrás buscarlos por nombre o etapa. (<label
              @mouseover="GuiaVisible = true"
              @mouseout="GuiaVisible = false"
              class="instrucciones--liga-etapas"
              >Ver etapas</label
            >)
          </p>
          <div class="instrucciones--tooltip" v-if="GuiaVisible">
            <etapas-prospecto-guia></etapas-prospecto-guia>
          </div>
        </div>
        <form>
          <div class="form-group col-12 mb-sm-2">
            <div class="w-75 wrapper-busqueda" style="margin: auto auto">
              <input
                type="text"
                class="form-control campo-administracion"
                placeholder="Buscar por nombre, etapa o sucursal"
                v-model="textoBusqueda"
                :disabled="prospectos.length <= 0"
              />
              <i class="fas fa-search icono-busqueda"></i>
            </div>
            <div>
              <br />
              <button
                v-if="
                  tipoUsuario == embajador ||
                    tipoUsuario == gerente ||
                    tipoUsuario == masterOperativo ||
                    tipoUsuario == administradorComercial ||
                    tipoUsuario == gerenteRegional
                "
                @click.prevent="nuevoProspecto()"
                class="btn boton-primario col-12 boton-buscar-administracion"
              >
                Nuevo prospecto
              </button>
            </div>
          </div>
        </form>
        <div v-if="prospectosFiltrados.length <= 0">
          <div
            v-if="textoBusqueda === ''"
            class="lead text-light mt-6 texto-lista-vacia"
          >
            <img
              src="https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/spinner_embajadores.gif"
              alt=""
              srcset=""
            />
            <p>Cargando...</p>
          </div>
          <p v-else class="lead text-light mt-6 texto-lista-vacia">
            No se encontraron resultados para tu búsqueda
          </p>
        </div>
        <div class="col-12 w-100" style="margin: auto auto">
          <div
            v-for="prospecto in prospectosFiltrados"
            v-bind:key="prospecto.prospectoId"
          >
            <TarjetaProspecto
              v-if="
                tipoUsuario == embajador ||
                  tipoUsuario == prospecto ||
                  tipoUsuario == preautorizador ||
                  tipoUsuario == administrador ||
                  tipoUsuario == gerente ||
                  tipoUsuario == masterOperativo ||
                  tipoUsuario == administradorComercial ||
                  tipoUsuario == gerenteRegional
              "
              :nombreProspecto="prospecto.nombres"
              :apellidoPaterno="prospecto.apellidoPaterno"
              :apellidoMaterno="prospecto.apellidoMaterno"
              :montoDeseado="prospecto.montoDeseado"
              :prospectoId="prospecto.prospectoId"
              :aliasEtapaStr="
                NombreEtapaTipoPersona(
                  prospecto.aliasEtapaStr,
                  prospecto.tipoPersona
                )
                  .charAt(0)
                  .toUpperCase() +
                  NombreEtapaTipoPersona(
                    prospecto.aliasEtapaStr,
                    prospecto.tipoPersona
                  )
                    .slice(1)
                    .toLowerCase()
              "
              :tipoPersona="prospecto.tipoPersona"
              :toolTip="InsertarTooltip(prospecto.aliasEtapaStr)"
              :etapa="prospecto.aliasEtapaStr"
              :etapaId="prospecto.etapaId"
              :sucursal="prospecto.sucursal"
              :embajador="prospecto.embajador"
              @ConsultarEstatus="
                ConsultarEstatusProspecto(prospecto.prospectoId)
              "
            ></TarjetaProspecto>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="js">
// Componentes
import TarjetaProspecto from "../../Prospecto/components/TarjetaProspecto.vue";
import EtapasProspectoGuia from "../../Prospecto/components/EtapasProspectoGuia.vue";
import axios from "axios";
import servicios from '../../../servicios/service.js';
//Rutas de api
var rutaProspectos = "/api/Master/Prospecto/ListarProspectos";
//var rutaProspectosPorRol = "/api/Master/Prospecto/ListarProspectosPorRol";
var rutaDescargarArchivoDA  = "/api/Master/CajaDorada/LlenarDeclaracionAdicional";
var rutaProspectosPorJerarquia = "/api/Master/Prospecto/ListarProspectosPorJerarquia";

export default {
  name: "AdministracionDeProspectos",
  components: {
    TarjetaProspecto,
    EtapasProspectoGuia
  },
  computed: {
    prospectosFiltrados() {
      if(this.textoBusqueda == "")
        return this.prospectos;
      else {
        let arregloPalabras = this.textoBusqueda.split(/[ ,]+/).filter(f => f.length);
        let esEtapa = this.prospectos.map(p => p.aliasEtapaStr).some(p => p.startsWith(this.textoBusqueda.toUpperCase()));
        let esSucursal = this.prospectos.map(p => p.sucursal).some(p => p.startsWith(this.textoBusqueda.toUpperCase()));
        return this.prospectos.filter(prospecto => {
          if(esEtapa) return arregloPalabras.some(p => prospecto.aliasEtapaStr.toUpperCase().startsWith(p.toUpperCase()));
          else if(esSucursal) return arregloPalabras.some(p => prospecto.sucursal.toUpperCase().startsWith(p.toUpperCase()));
          let nombreCompleto = prospecto.nombres + " " + prospecto.apellidoPaterno + " " +  prospecto.apellidoMaterno;
          let nombreCompletoExtranjero = prospecto.nombres + " " + prospecto.apellidoMaterno + " " +  prospecto.apellidoPaterno;
          return arregloPalabras.some(p => nombreCompleto.includes(p.toUpperCase()) || nombreCompletoExtranjero.includes(p.toUpperCase()));
        });
      }
    }
  },
  data() {
    return {
      embajadoresInactivo: 0,
      embajador: 1,
      prospectoInactivo: 2,
      prospecto: 3,
      preautorizador: 4,
      administrador: 5,
      gerente: 6,
      masterComercial: 7,
      masterOperativo: 8,
      gerenteRegional: 9,
      administradorComercial: 10,
      etiquetaBusqueda: "ejemplo",
      tipoUsuario: null,
      prospectos: [],
      textoBusqueda: "",
      token: null,
      apoyoEstatusProspectoId: null,
      GuiaVisible: false
    };
  },
  watch: {
  },
  async mounted() {
    if(servicios.SesionExpirada()) {
       this.$fire({
        title: "Sesión expirada.",
        confirmButtonText: "Aceptar",
        showCancelButton: false,
        allowOutsideClick: false,
      }).then(result => {
        if(result.value){
          this.$router.push({
            name: "LoginMaster"
          });
        }
      });
    } else {
        this.tipoUsuario = this.$store.getters.tipoUsuario;
        window.sessionStorage.removeItem('prospectoEditarId');
        window.sessionStorage.removeItem('prospectoId');
        this.cargarProspectos();
    }
  },
  methods:{
    NombreEtapaTipoPersona(aliasEtapa, tipoPersona){
      switch (aliasEtapa)
      {
      case "PRIMER CONTACTO":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "FIRST CONTACT" : aliasEtapa;
      case "ASESORÍA":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "ADVICE" : aliasEtapa;
      case "INTEGRACIÓN DE EXPEDIENTE":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "FILE INTEGRATION" : aliasEtapa;
      case "PRE AUTORIZACIÓN":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "PRE-AUTHORIZATION" : aliasEtapa;
      case "GENERACIÓN INFORMACIÓN DE PAGO":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "GENERATION OF PAYMENT INFORMATION" : aliasEtapa;
      case "PAGO DE CUOTA DE INSCRIPCIÓN":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "PAYMENT OF REGISTRATION FEE" : aliasEtapa;
      case "VALIDAR PAGO":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "VALIDATE PAYMENT" : aliasEtapa;
      case "CONTRATADO":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "CONTRACTED" : aliasEtapa;
      case "PAUSADO":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "PAUSED" : aliasEtapa;
      case "COMPLETADO":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "COMPLETED" : aliasEtapa;
      case "HOJA PRUEBA":
      return (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? "TEST SHEET" : aliasEtapa;
      }
    },
    InsertarTooltip(etapa){
      switch (etapa) {
        case 'PRIMER CONTACTO':
          return "Primer acercamiento con el prospecto donde nos presentamos y en ese mismo sentido se ofrece una breve explicación del financiamiento, invitando al prospecto a concertar una cita e indagar sobre el tema";
        case 'ASESORÍA':
          return "Nuestros asesores expertos te guían para solicitar la mejor opción de financiamiento, acorde a tu perfil. ";
        case 'INTEGRACIÓN DE EXPEDIENTE':
          return "Resguardamos los documentos como fuente de información, para la organización y desarrollo de cada proceso. ";
        case 'PRE AUTORIZACIÓN':
          return "Verificamos el cumplimiento de ciertos requisitos, para hacer uso del financiamiento.";
        case 'GENERACIÓN INFORMACIÓN DE PAGO':
          return "Notificamos al cliente los datos, para realizar el pago de la cuota de inscripción.";
        case 'PAGO DE CUOTA DE INSCRIPCIÓN':
          return "El cliente realizara el pago de su cuota de inscripción vía online o cargará su comprobante de pago en ventanilla.";
        case 'VALIDAR PAGO':
          return "Confirmación del pago en firme, por parte del Área de Tesorería.";
        case 'COTRATADO':
          return "Por último, el cliente recibirá el contrato para su revisión y firma.";
        case 'PAUSADO':
          return "Prospecto pausado.";
        default:
          break;
      }
    },
    nuevoProspecto() {
      this.$store.commit('setCrearProspecto', true);
      this.$store.commit('setEditarProspecto', false);
      this.$store.commit('setRegistroFiguraAdicional',false);
      this.$router.push({
        name: "RegistroProspecto"
      });
    },
    cargarProspectos(){
      if(this.tipoUsuario != 4 && this.tipoUsuario != 5 && this.tipoUsuario != 6 && this.tipoUsuario != 8 && this.tipoUsuario != 9 && this.tipoUsuario != 10) {
        const cuerpo = {
          params:{
            NombreOEtapa:this.textoBusqueda,
            FiltrarPorMaster:true,
          }
        }
        axios
        .get(rutaProspectos,cuerpo)
        .then((response) => {
          if (response.data.estado === 0)
            this.prospectos = response.data.data;
        }).catch((e) => this.ManejarExcepcion(e));
      } else {
        this.cargarPropectosPorRol();
      }
    },
    cargarPropectosPorRol() {
      axios
      .get(rutaProspectosPorJerarquia)
      .then((response) => {
        if (response.data.estado === 0) {
          this.prospectos = response.data.data;
        }
      })
      .catch((e) => {
        this.ManejarExcepcion(e);
      });
    },
    AbriDoc(){
       window.location.href =
            rutaDescargarArchivoDA + "?nombre=juan";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color-primario: #b8725a;
$blanco: #ffffff;
$negro-embajadores: #1e2120;
$poppins: "Poppins";

.administracion-prospectos {
  background: url("https://hircasageneral.blob.core.windows.net/embajadores-manager/img/images/img_admon.png")
    no-repeat center center fixed;
  background-size: cover;
  width: 100vw;
  flex-grow: 1;
}
.contenedor-form {
  display: inline-table;
  width: 50vw !important;
}
.campo-administracion {
  border-radius: 0px;
  border-style: none;
  font-family: $poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.05em;
  height: 50px;
}
.etiqueta-administracion {
  float: left;
  color: $blanco;
  font-family: $poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.05em;
}
.texto-lista-vacia {
  font-family: Poppins;
  margin-top: 5%;
}
.boton-buscar-administracion {
  background-color: $color-primario;
  border: 1px solid $color-primario;
  border-radius: 0px;
  font-family: $poppins;
  height: 50px;
  color: $blanco;
  width: 50%;
  margin-top: 20px;
}
.boton-buscar-administracion:hover {
  background-color: #a56651;
  color: white;
}

.contenedor-prospectos {
  display: inline-table;
  width: 50vw !important;
}
/*Icono buscar*/

.wrapper-busqueda .icono-busqueda {
  position: absolute;
}

.wrapper-busqueda {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.icono-busqueda {
  padding-top: 12px;
  padding-right: 12px;
  color: $color-primario;
  font-size: 24px;
  opacity: 0.8;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .contenedor-form {
    display: inline-table;
    width: 80vw !important;
  }
  .contenedor-prospectos {
    display: inline-table;
    width: 80vw !important;
  }
  .boton-buscar-administracion {
    width: 80%;
    margin-top: 20px;
  }
}
/**ESTILOS MOBILE */
@media (max-width: 767px) {
  .contenedor-form {
    display: inline-table;
    width: 80vw !important;
  }
  .contenedor-prospectos {
    display: inline-table;
    width: 80vw !important;
  }
  .boton-buscar-administracion {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
